export default __webpack_public_path__ + "static/media/practice_left_bg.65a53aba.png";